import { apiFetch } from '../services/apiFetch';

const API_URL = import.meta.env.VITE_API_URL;

// targetType: 0 = Expense, 1 = Invoice (ScanTargetType enum on the server).
// Returns [{ id, name, sortOrder }] scoped to the caller's company.
export async function fetchCategoriesByTarget(targetType) {
    const res = await apiFetch(`${API_URL}/api/Category/GetByTarget/${targetType}`, { method: 'GET' });
    if (!res.ok) throw new Error(`Failed to fetch categories: ${res.status}`);
    return res.json();
}
